import { Luscinia, luscinia } from "./luscinia";

var gritters: Record<string, number> = {};
var jobRunNotifications: Record<string, JobRunNotification> = {};
var openingJobModal = false;

class JobRunNotification {
    jobRunId: string;
    name: string;
    status: number;
    statusName: string;

    constructor() {
        this.jobRunId = "";
        this.name = "";
        this.status = 0;
        this.statusName = "";
    }
};

luscinia.initJobNotifications = function () {
    $.get("/data/jobruns/notifications", function (notifications: JobRunNotification[]) {
        for (var notification of notifications) {
            jobRunNotifications[notification.jobRunId] = notification;

            let styleClass = "clean";
            switch (notification.status) {
                case 0://Queued
                    styleClass = "primary";
                    break;
                case 1://Running
                    styleClass = "primary";
                    break;
                case 2://Succeeded
                    styleClass = "success";
                    break;
                case 3://Failed
                    styleClass = "danger";
                    break;
            }
            var currentNotification = $(".jobRunNotification-" + notification.jobRunId);
            if (currentNotification.length === 0) {
                gritters[notification.jobRunId] = ($ as any).gritter.add({
                    title: notification.name,
                    class_name: styleClass + " jobRun jobRunNotification-" + notification.jobRunId,
                    sticky: true,
                    time: '',
                    position: 'bottom-right',
                    after_open: function (element: HTMLElement) {
                        var jobRunId = "";
                        var jobRunClasses = ($(element).attr('class') as string).split(' ');
                        for (var jobClass of jobRunClasses) {
                            if (jobClass.startsWith("jobRunNotification-")) {
                                jobRunId = jobClass.substr("jobRunNotification-".length);
                            }
                        }
                        $(element).attr("jobRunId", jobRunId);
                        var localNotification = jobRunNotifications[jobRunId];

                        $(element).find(".gritter-without-image").append("<p class='statusName'>" + localNotification.statusName + "</p>");
                        $(element).find(".gritter-without-image").css("cursor:pointer;");
                        $(element).find(".gritter-without-image").click(function (e) {
                            if ($(`.joboverview[logid='${localNotification.jobRunId}']`).length === 0 && openingJobModal === false) {
                                openingJobModal = true;
                                luscinia.openCustomModal(`/data/jobruns/modal/${localNotification.jobRunId}`).then(function () {
                                    openingJobModal = false;
                                });
                            }
                        });
                        $(element).find(".gritter-close").click(function (e) {
                            $.post("/data/jobruns/setnotificationread", { jobRunId: localNotification.jobRunId });
                        });
                    },
                    before_close: function (element: HTMLElement) {
                        var jobRunId = $(element).attr("jobRunId") as string;
                        var localNotification = jobRunNotifications[jobRunId];
                        $.post("/data/jobruns/setnotificationread", { jobRunId: localNotification.jobRunId });
                    }
                });
            }
            else {
                if (currentNotification.find(".statusName").html() !== notification.statusName) {
                    currentNotification.find(".statusName").html(notification.statusName);
                }
                if (!currentNotification.hasClass(styleClass)) {
                    currentNotification.removeClass("primary");
                    currentNotification.removeClass("success");
                    currentNotification.removeClass("danger");
                    currentNotification.addClass(styleClass);
                }
                if (!currentNotification.hasClass("removalscheduled") && (currentNotification.hasClass("success") || currentNotification.hasClass("danger"))) {
                    currentNotification.addClass("removalscheduled");
                    setTimeout(function (jobRunId:string) {
                        var gritterId = gritters[jobRunId];
                        ($ as any).gritter.remove(gritterId);
                    }, 5000, currentNotification.attr("jobRunId") as string);
                }
            }
        }

        // setTimeout(luscinia.initJobNotifications, 2500);
    });
};